<template>
 <div>
   <div class="p-fluid p-formgrid p-grid">
     <div class="p-field p-col-12 p-md-9"></div>
     <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised p-button-secondary btn" @click="generateReport" label="Print" icon="pi pi-print"/>
     </div>
    <div class="p-field p-col-12 p-md-1">
      <Button class="p-button-raised p-button-danger btn" @click.prevent="$router.back()" label="Cancel"/>
    </div>
  </div>
    <Card>
      <template #content>
     <div class="p-grid">
       <div class="p-col-2">
         <span class="logo-mini">
      <a href=""><img :src="$store.state.organisationLogo" alt="Logo" class="img-responsive center-block logo"></a>
    </span>
       </div>
       <div class="p-col-6" style="text-align:center">
         <h3><b>{{organisationName}}</b></h3>
       </div>

     </div>
     <div class="p-grid">
       <div class="p-col-2">
       </div>
       <div class="p-col-6" style="margin-top: -1%;text-align: -webkit-center;">
         <h4>{{organisationPanVatNo}}</h4>
       </div>
       <div class="p-col-4">
       </div>
     </div>
     <div class="p-grid">
       <div class="p-col-2">
       </div>
       <div class="p-col-6" style="margin-top: -1%;text-align: -webkit-center;">
         <h4>{{organisationAddress}}</h4>
       </div>
       <div class="p-col-4">
       </div>
     </div>
     <div class="p-grid">
       <div class="p-col-2">
       </div>
       <div class="p-col-6">
         <h5 style="margin-top: -1%;text-align: -webkit-center;">{{organisationContact}}</h5>
       </div>
       <div class="p-col-4"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-4">
         <h3><b>{{voucherType}}</b></h3>
       </div>
       <div class="p-col-6">
       </div>
       <div class="p-col-2"></div>
     </div>
     <div class="p-grid">
       <div class="p-col-4" style="margin-top: -1%;">
         <h4>Voucher No:- {{voucherNo}}</h4>
       </div>
       <div class="p-col-4">
       </div>
       <div class="p-col-4">
         <label>Date: {{nepaliDate}}{{englishDate}}</label>
       </div>
     </div>
     <table class="table table-bordered">
       <thead>
         <tr>
           <th style="text-align:center">Account</th>
           <th style="text-align:center">Debit</th>
           <th style="text-align:center">Credit</th>
           <th style="text-align:center" >Cheque Date</th>
           <th style="text-align:center" >Cheque Number</th>
           <th style="text-align:center">Short Narration</th>
        </tr>
       </thead>
       <tbody v-for="(account,index) in voucherList " :key="index">
         <tr>
           <!-- <td>{{index+1}}</td> -->
           <td>{{account.accountMaster.name}}</td>
           <td style="text-align:right;color:#00a65a;">{{account.drCr == 'D'?account.txnAmount:''}}</td>
           <td style="text-align:right;color:#dd4b39;">{{account.drCr == 'C'?account.txnAmount:''}} </td>
           <td>{{account.chequeDate}} </td>
           <td>{{account.chequeNumber}} </td>
           <td >{{account.narration3}} </td>
         </tr>
       </tbody>
     </table>
     <div class="p-grid">
       <div class="p-col-6">
         <strong>Narration: {{narration}}</strong>
       </div>
       <div class="p-col-6"></div>
       <!-- <div class="p-col-2"></div> -->
     </div>
     <!-- <template #footer> -->
       <div class="p-grid">
         <div class="p-col-6" style="text-align: left;"><strong>Prepared By: {{userName}}</strong></div>
         <div class="p-col-2"></div>
         <div class="p-col-4" style="text-align: left;"><strong>Approved By: ..............................</strong></div>
       </div>
     </template>
  </Card>
</div>
</template>
<script>
import Button from 'primevue/button'
import Card from 'primevue/card'
export default {
  name: 'voucher',
  props: ['printData'],
  data() {
    return {
      organisationName: '',
      organisationAddress: '',
      organisationContact: '',
      organisationLogo: '',
      organisationPanVatNo: '',
      voucherNo: null,
      englishDate: null,
      nepaliDate: null,
      voucherList: [],
      narration: '',
      userName: '',
      voucherType: ''
    }
  },
  mounted () {
    this.openVoucherDialog()
  },
  methods: {
    async openVoucherDialog() {
      let journalLeg = {
        tranId: this.printData.tranId,
        tranModuleType: this.printData.tranModuleType
      }
      let response = await this.$store.dispatch('loadaccountLedger', journalLeg)
      this.organisationName = this.$store.state.organisationName
      this.organisationLogo = this.$store.state.organisationLogo
      this.organisationPanVatNo = this.$store.organisationPanVatNo
      this.organisationAddress = this.$store.state.organisationAddress
      this.organisationContact = this.$store.state.organisationContact
      this.userName = response.data.data.enterBy
      this.narration = response.data.data.narration1
      this.voucherNo = response.data.data.voucher
      this.voucherList = response.data.data.transactionDetailDTOList
      this.nepaliDate = response.data.data.transactionNepaliDate
      this.voucherType = response.data.data.reportName
    },
    generateReport () {
      window.print()
    }
  },
  components: {
    Button,
    Card
  }
}
</script>
<style scoped >
@media print {
    .btn {
      display: none;
    }
}
</style>



// WEBPACK FOOTER //
// voucher.vue?77550f7e